const _checkSpace = (text, i) => {
  if (i >= text.length) return false
  return /[ ]+/.test(text[i])
}

const _isApostrophe = (text, i) =>
  text[i] === `'` &&
  i < text.length - 1 &&
  ['s', 'd', 't', 'm'].includes(text[i + 1]) &&
  (i === text.length - 2 || text[i + 2] === ' ')

// Divide a long text (string) into an array of strings
export const divideText = text => {
  const textArray = []
  let counter = 0
  let thisT = ''
  for (let i = 0; i < text.length; i++) {
    if (/[^\w\s]|_|[ ]+/.test(text[i])) {
      // This char is punctuation or space
      if (thisT.length) textArray.push([thisT, /[ ]+/.test(text[i]), counter++])
      if (!/[ ]+/.test(text[i]) && !_isApostrophe(text, i))
        textArray.push([text[i], _checkSpace(text, i + 1), counter++])
      else if (_isApostrophe(text, i)) {
        // Special case - ' that is followed by s, d, t, or m, i.e. I'm it's I'd don't etc.
        textArray.push([`'` + text[i + 1], _checkSpace(text, i + 2), counter++])
        i++
      }
      thisT = ''
    } else {
      thisT += text[i]
      if (i === text.length - 1) {
        textArray.push([thisT, false, counter++])
      }
    }
  }
  return textArray
}

// divideText(`'s 's 's's.`)
// divideText(`; apple! .a`)
// divideText(`  apple a ss ' s s's `)

// Check if a string contains only punctuation
export const checkMark = t => {
  for (let i = 0; i < t.length; i++) {
    if (!/[^\w\s]|_/.test(t.charAt(i))) return false
  }
  return true
}

export const joinTextArray = (textArray, omitLastSpace = false) => {
  if (!textArray) return ''
  if (!textArray.length) return ''

  let t = ''
  for (let a of textArray.slice(0, -1)) {
    t += a[0]
    t += a[1] ? ' ' : ''
  }

  const last = textArray.slice(-1)[0]
  t += last[0] + (last[1] && !omitLastSpace ? ' ' : '')

  return t
}
